// Angular Modules
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { CdkTableModule } from '@angular/cdk/table';

// Material & Flex Layout
import { SharedMaterialModule } from './shared-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';

// Components
import { HeaderComponent, FooterComponent, DialogComponent, DialogUploadingComponent, DialogLargeComponent, DialogExtraLargeComponent } from './components';

// Services
import { AuthGuard } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { LogicService } from './services/logic.service';
import { UploadService } from './services/upload.service';
import { QuizService } from './services/quiz.service';
import { ErrorService } from './services/error.service';
import { WindowRef } from './services/window.service';

// Pipes
import { ObjectToArrayPipe } from './pipes/objectToArray.pipe';
import { SafeUrlPipe } from './pipes/safeUrl.pipe';



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    DialogComponent,
    DialogUploadingComponent,
    DialogLargeComponent,
    DialogExtraLargeComponent,
    ObjectToArrayPipe,
    SafeUrlPipe
  ],
  imports: [
    // Angular Modules
    RouterModule,
    CommonModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTableModule,
    // Material & Flex Layout
    SharedMaterialModule,
    FlexLayoutModule
  ],
  exports:  [
    // Angular Modules
    RouterModule,
    CommonModule,
    HttpClientModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    CdkTableModule,
    // Material & Flex Layout
    SharedMaterialModule,
    FlexLayoutModule,
    // Components
    HeaderComponent,
    FooterComponent,
    DialogComponent,
    DialogUploadingComponent,
    DialogLargeComponent,
    DialogExtraLargeComponent,
    ObjectToArrayPipe,
    SafeUrlPipe
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        AuthGuard,
        AuthService,
        LogicService,
        UploadService,
        QuizService,
        ErrorService,
        WindowRef
      ]
    };
  }
}
